import { StoppageToSave, StoppageType } from '../types';
import { tosApi } from './tosApi';
import { getInvalidatesTags } from './utils';

export const stoppageApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    updateStoppage: build.mutation<StoppageType, StoppageToSave>({
      query: (stoppage) => {
        return {
          url: `/operational/stoppages/${stoppage.id}`,
          method: 'PUT',
          body: stoppage,
        };
      },
      invalidatesTags: (_result, error, queryArg) =>
        getInvalidatesTags(error, [
          { type: 'OperationCalculus', code: queryArg.operation_id },
        ]),
    }),
    createStoppage: build.mutation<StoppageType, StoppageToSave>({
      query: (stoppage) => {
        return {
          url: `/operational/stoppages`,
          method: 'POST',
          body: stoppage,
        };
      },
      invalidatesTags: (_result, error, queryArg) =>
        getInvalidatesTags(error, [
          { type: 'OperationCalculus', code: queryArg.operation_id },
        ]),
    }),
    deleteStoppage: build.mutation<void, number>({
      query: (stoppageId) => {
        return {
          url: `/operational/stoppages/${stoppageId}`,
          method: 'DELETE',
        };
      },
      invalidatesTags: (result, error, queryArg) =>
        getInvalidatesTags(error, [
          { type: 'OperationCalculus', code: queryArg },
        ]),
    }),
    bulkDeleteStoppages: build.mutation<
      void,
      { ids: number[]; operation_id: number }
    >({
      query: (data) => {
        return {
          url: `/operational/stoppages/bulk-delete`,
          method: 'DELETE',
          body: { ids: data.ids },
        };
      },
      invalidatesTags: (result, error, queryArg) =>
        getInvalidatesTags(error, [
          { type: 'OperationCalculus', code: queryArg.operation_id },
        ]),
    }),
    importStoppages: build.mutation<
      {
        imported_count: number;
        stoppages?: StoppageType[];
        error_count: number;
        error_details: Array<{
          item: string | number;
          error_type: string;
          message: string;
          overlap_with_item?: string | number;
        }>;
      },
      { file: File; operation_id: number }
    >({
      query: ({ file, operation_id }) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('operation_id', operation_id.toString());
        return {
          url: `/operational/stoppages/import`,
          method: 'POST',
          body: formData,
          formData: true,
        };
      },
      invalidatesTags: (_result, error, queryArg) =>
        getInvalidatesTags(error, [
          { type: 'OperationCalculus', code: queryArg.operation_id },
        ]),
    }),
  }),
});

export const {
  useUpdateStoppageMutation,
  useCreateStoppageMutation,
  useDeleteStoppageMutation,
  useBulkDeleteStoppagesMutation,
  useImportStoppagesMutation,
} = stoppageApi;
